export const STORE_URL = 'https://play.google.com/store/apps/details?id=kr.co.datau.mfinder'
export const REMOTE_URL = 'https://svc.mfinder.co.kr/'
export const DATAU_URL = 'https://www.datauniverse.co.kr'
export const BLOG_URL = 'https://blog.naver.com/datau1'

export const ASK_TERMS = `1:1문의 이용약관\n 1. 수집 정보 ㈜데이터유니버스는 이용자의 원활한 고객상담 및 불만처리를 위하여 아래와 같은 정보를 수집 합니다.\n * 수집 정보 : 이름, 연락처, 이메일 주소, 고객의 문의/답변 내용에 포함된 정보\n 2. 수집 및 이용 목적\n수집된 정보는 고객문의 및 상담요청에 대하여 회신을 하거나, 상담을 위한 서비스 이용기록 조회를 목적으로 활용합니다.\n3. 보관 및 이용 기간\n이용자의 정보는 문의 처리 이후 3년간 보관 후 파기됩니다.`

export const TELECOM = [
  { label: 'SKT', value: 0 },
  { label: 'KT', value: 1 },
  { label: 'LG U+', value: 2 },
]

export const QNA_TYPE = ['서비스가입', '서비스해지', '이용문의', '제휴문의', '기타']
export const PHONE_PREFIX = ['010', '011', '016', '017', '018', '019']

export const BANK_LIST = [
  '기업은행',
  '국민은행',
  '신한은행',
  '우리은행',
  'KEB하나은행',
  '농협은행',
  '지역농축협',
  'SC제일은행',
  '한국시티은행',
  '우체국',
  '경남은행',
  '광주은행',
  '대구은행',
  '도이치',
  '부산은행',
  '산림조합',
  '산업은행',
  '저축은행',
  '새마을금고',
  '수협',
  '신협',
  '전북은행',
  '제주은행',
  'BOA',
  'HSBC',
  'JP모간',
  '중국공상은행',
  '비엔피파리바은행',
  '중국건설은행',
  '카카오뱅크',
  '케이뱅크',
  '교보증권',
  '대신증권',
  '미래에셋대우',
  'DB금융투자',
  '유안타증권',
  '메리츠증권',
  '부국증권',
  '삼성증권',
  '솔로몬투자증권',
  '신영증권',
  '신한금융투자',
  'NH투자증권',
  '유진투자증권',
  '이베스트증권',
  '키움증권',
  '하나금융투자',
  '하이투자',
  '한국투자',
  '한화증권',
  'KB증권',
  '현대차투자증권',
  '토스뱅크',
  '케이프투자증권',
  'SK증권',
  'KTB투자증권',
  '한국포스증권',
]
